module.exports = __webpack_public_path__ + "static/Rajani-7d6eec7a171618520bd53155d5b752e4.png";